import React from 'react';
import {
  AuditLogType,
  ChangeSet,
} from '@upstart/harmony/lib/legos/financingTypes';
import { PropertyChange } from './PropertyChange';
import './LogGroup.scss';

export interface LogGroupProps {
  changeSet: ChangeSet;
}

export const LogGroup: React.FC<LogGroupProps> = ({ changeSet }) => (
  <div className="groupContainer">
    {changeSet.changeLogs.map(changeLog =>
      changeLog.type === AuditLogType.PROPERTY_CHANGE ? (
        <PropertyChange propertyChange={changeLog} />
      ) : (
        <div />
      ),
    )}
    <div className="userContainer">
      <div>
        All the above changes were made by{' '}
        <span className="nameValue">
          {changeSet.createdBy ?? 'Unknown User'}
        </span>{' '}
        <span className="dateValue">
          {'on '}
          {formatDate(changeSet.createdAt)}
        </span>
      </div>
    </div>
  </div>
);

function formatDate(date?: Date) {
  if (date) {
    return new Date(date).toLocaleString().replace(/,/g, ' at ');
  }
  return 'unknown time';
}
